{
  "HELP_CENTER": {
    "TITLE": "Довідковий центр",
    "NEW_PAGE": {
      "DESCRIPTION": "Створюйте портали довідкового центру для самообслуговування ваших клієнтів. Допоможіть їм швидко знаходити відповіді, не чекаючи. Оптимізуйте запити, підвищуйте ефективність агентів і покращуйте якість підтримки клієнтів.",
      "CREATE_PORTAL_BUTTON": "Створити портал"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Без назви"
    },
    "HEADER": {
      "FILTER": "Фільтрувати за",
      "SORT": "Сортувати за",
      "LOCALE": "Локаль",
      "SETTINGS_BUTTON": "Налаштування",
      "NEW_BUTTON": "Нова стаття",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Опубліковано",
        "DRAFT": "Draft",
        "ARCHIVED": "Архівовано"
      },
      "TITLES": {
        "ALL_ARTICLES": "Всі статті",
        "MINE": "Мої статті",
        "DRAFT": "Draft-статті",
        "ARCHIVED": "Архівовані статті"
      },
      "LOCALE_SELECT": {
        "TITLE": "Виберіть мову",
        "PLACEHOLDER": "Виберіть мову",
        "NO_RESULT": "Локаль не знайдено",
        "SEARCH_PLACEHOLDER": "Пошук локалі"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Всі статті",
      "PUBLISH_BUTTON": "Опублікувати",
      "MOVE_TO_ARCHIVE_BUTTON": "Перемістити в архів",
      "PREVIEW": "Попередній перегляд",
      "ADD_TRANSLATION": "Додати переклад",
      "OPEN_SIDEBAR": "Відкрити бічну панель",
      "CLOSE_SIDEBAR": "Закрити бічну панель",
      "SAVING": "Збереження...",
      "SAVED": "Збережено"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Завантажити зображення",
        "UPLOADING": "Завантажується...",
        "SUCCESS": "Зображення успішно завантажено",
        "ERROR": "Помилка при завантаженні зображення",
        "UN_AUTHORIZED_ERROR": "У вас немає прав для завантаження зображень",
        "ERROR_FILE_SIZE": "Зображення має бути менше {size}Мб",
        "ERROR_FILE_FORMAT": "Формат зображення повинен бути jpg, jpeg або png",
        "ERROR_FILE_DIMENSIONS": "Розміри зображення повинні бути менші ніж 2000 х 2000"
      },
      "ANCHOR": {
        "BUTTON": "Вставити якір",
        "TITLE": "Вставити якір",
        "SUBMIT": "Вставити",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Налаштування статті",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Категорія",
          "TITLE": "Виберіть категорію",
          "PLACEHOLDER": "Виберіть категорію",
          "NO_RESULT": "Категорію не знайдено",
          "SEARCH_PLACEHOLDER": "Пошук категорії"
        },
        "AUTHOR": {
          "LABEL": "Автор",
          "TITLE": "Виберіть автора",
          "PLACEHOLDER": "Виберіть автора",
          "NO_RESULT": "Авторів не знайдено",
          "SEARCH_PLACEHOLDER": "Пошук автора"
        },
        "META_TITLE": {
          "LABEL": "Мета-заголовок",
          "PLACEHOLDER": "Додати мета-заголовок"
        },
        "META_DESCRIPTION": {
          "LABEL": "Мета-опис",
          "PLACEHOLDER": "Додати мета-опис для кращих SEO результатів..."
        },
        "META_TAGS": {
          "LABEL": "Мета-теги",
          "PLACEHOLDER": "Додавайте мета-теги, розділені комами..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Архівувати статтю",
        "DELETE": "Видалити статтю"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Без категорії",
      "SEARCH_RESULTS": "Результати пошуку для {query}",
      "EMPTY_TEXT": "Пошук статей для вставки у відповіді.",
      "SEARCH_LOADER": "Шукаємо...",
      "INSERT_ARTICLE": "Вставити",
      "NO_RESULT": "Статей не знайдено",
      "COPY_LINK": "Скопіювати посилання на статтю в буфер обміну",
      "OPEN_LINK": "Відкрити статтю в новій вкладці",
      "PREVIEW_LINK": "Перегляд статті"
    },
    "PORTAL": {
      "HEADER": "Портали",
      "DEFAULT": "За замовчуванням",
      "NEW_BUTTON": "Новий портал",
      "ACTIVE_BADGE": "активний",
      "CHOOSE_LOCALE_LABEL": "Виберіть мову",
      "LOADING_MESSAGE": "Завантаження порталів...",
      "ARTICLES_LABEL": "статті",
      "NO_PORTALS_MESSAGE": "Немає доступних порталів",
      "ADD_NEW_LOCALE": "Додати нову локаль",
      "POPOVER": {
        "TITLE": "Портали",
        "PORTAL_SETTINGS": "Налаштування порталу",
        "SUBTITLE": "У вас є кілька порталів і можна мати різні локалі для кожного порталу.",
        "CANCEL_BUTTON_LABEL": "Скасувати",
        "CHOOSE_LOCALE_BUTTON": "Виберіть локаль"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "статті",
            "ADD": "Додати локаль",
            "VISIT": "Відвідати сайт",
            "SETTINGS": "Налаштування",
            "DELETE": "Видалити"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Конфігурації порталу",
            "ITEMS": {
              "NAME": "Ім'я",
              "DOMAIN": "Користувацький домен",
              "SLUG": "Мітка",
              "TITLE": "Заголовок порталу",
              "THEME": "Колір теми",
              "SUB_TEXT": "Додатковий текст порталу"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Доступні локалі",
            "TABLE": {
              "NAME": "Назва локалі",
              "CODE": "Код локалі",
              "ARTICLE_COUNT": "Кількість статей",
              "CATEGORIES": "Кількість категорій",
              "SWAP": "Поміняти",
              "DELETE": "Видалити",
              "DEFAULT_LOCALE": "За замовчуванням"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Видалити портал",
          "MESSAGE": "Ви дійсно бажаєте видалити цей портал",
          "YES": "Так, видалити портал",
          "NO": "Ні, зберегти портал",
          "API": {
            "DELETE_SUCCESS": "Портал успішно видалено",
            "DELETE_ERROR": "Помилка під час видалення порталу"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Редагувати портал",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Основна інформація"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Оформлення порталу"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Категорії"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Локалі"
          }
        },
        "CATEGORIES": {
          "TITLE": "Категорії в",
          "NEW_CATEGORY": "Нова категорія",
          "TABLE": {
            "NAME": "Ім'я",
            "DESCRIPTION": "Опис",
            "LOCALE": "Локаль",
            "ARTICLE_COUNT": "Кількість статей",
            "ACTION_BUTTON": {
              "EDIT": "Редагувати категорію",
              "DELETE": "Видалити категорію"
            },
            "EMPTY_TEXT": "Категорій не знайдено"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Оновити основні налаштування"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Інформація по центру допомоги",
            "BODY": "Основна інформація про портал"
          },
          "CUSTOMIZATION": {
            "TITLE": "Оформлення центру довідки",
            "BODY": "Налаштування порталу"
          },
          "FINISH": {
            "TITLE": "Ура! 🎉",
            "BODY": "Все готово!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Назад",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Створити портал",
            "TITLE": "Інформація по центру допомоги",
            "CREATE_BASIC_SETTING_BUTTON": "Створити базові налаштування порталу"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Налаштування порталу",
            "TITLE": "Оформлення центру довідки",
            "UPDATE_PORTAL_BUTTON": "Оновити налаштування порталу"
          },
          "FINISH_PAGE": {
            "TITLE": "Ура!🎉 Все готово!",
            "MESSAGE": "Тепер ви можете побачити цей портал на вашій сторінці порталів.",
            "FINISH": "Перейти на сторінку всіх порталів"
          }
        },
        "LOGO": {
          "LABEL": "Логотип",
          "UPLOAD_BUTTON": "Завантажити логотип",
          "HELP_TEXT": "Цей логотип буде показано у заголовку порталу.",
          "IMAGE_UPLOAD_SUCCESS": "Логотип успішно завантажено",
          "IMAGE_UPLOAD_ERROR": "Логотип успішно видалено",
          "IMAGE_DELETE_ERROR": "Помилка при видаленні логотипу"
        },
        "NAME": {
          "LABEL": "Ім'я",
          "PLACEHOLDER": "Назва порталу",
          "HELP_TEXT": "Ім'я буде використовуватися в публічному інтерфейсі порталу всередині.",
          "ERROR": "Назва обов'язкова"
        },
        "SLUG": {
          "LABEL": "Мітка",
          "PLACEHOLDER": "Портал slug для URL-адрес",
          "ERROR": "Необхідно вказати мітку"
        },
        "DOMAIN": {
          "LABEL": "Власний домен",
          "PLACEHOLDER": "Власний домен порталу",
          "HELP_TEXT": "Додавайте, лише якщо хочете використовувати власний домен для порталу. Напр.: {exampleURL}",
          "ERROR": "Введіть дійсну URL-адресу домену"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Посилання на головну сторінку",
          "PLACEHOLDER": "Посилання на головну сторінку порталу",
          "HELP_TEXT": "Посилання, яке використовується для повернення з порталу на головну сторінку. Напр.: {exampleURL}",
          "ERROR": "Введіть дійсний URL домашньої сторінки"
        },
        "THEME_COLOR": {
          "LABEL": "Колір теми порталу",
          "HELP_TEXT": "Цей колір буде показуватися як колір теми для порталу."
        },
        "PAGE_TITLE": {
          "LABEL": "Заголовок сторінки",
          "PLACEHOLDER": "Заголовок сторінки порталу",
          "HELP_TEXT": "Заголовок сторінки використовуватиметься в публічному порталі.",
          "ERROR": "Необхідно вказати заголовок сторінки"
        },
        "HEADER_TEXT": {
          "LABEL": "Текст заголовку",
          "PLACEHOLDER": "Текст заголовку порталу",
          "HELP_TEXT": "Текст заголовка порталу використовуватиметься в публічному порталі.",
          "ERROR": "Потрібен текст заголовка порталу"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Портал успішно створено.",
          "ERROR_MESSAGE_FOR_BASIC": "Не вдалося створити портал. Повторіть спробу.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Портал успішно оновлено.",
          "ERROR_MESSAGE_FOR_UPDATE": "Не вдалося оновити портал. Спробуйте ще раз."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Додати нову локаль",
        "SUB_TITLE": "Це додасть нову локалізацію до вашого списку перекладів.",
        "PORTAL": "Портал",
        "LOCALE": {
          "LABEL": "Локаль",
          "PLACEHOLDER": "Виберіть мову",
          "ERROR": "Потрібна локаль"
        },
        "BUTTONS": {
          "CREATE": "Створити локаль",
          "CANCEL": "Скасувати"
        },
        "API": {
          "SUCCESS_MESSAGE": "Локаль успішно додано",
          "ERROR_MESSAGE": "Не вдалося додати локаль. Спробуйте ще раз."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Локаль за замовчуванням успішно оновлено",
          "ERROR_MESSAGE": "Не вдалося оновити локаль за замовчуванням. Спробуйте ще раз."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Локаль успішно видалена з порталу",
          "ERROR_MESSAGE": "Не вдалося видалити локаль з порталу. Спробуйте ще раз."
        }
      }
    },
    "TABLE": {
      "404": "Немає статей, які відповідають вашому пошуку 🔍",
      "LOADING_MESSAGE": "Завантаження статей...",
      "NO_ARTICLES": "Немає доступних статей",
      "HEADERS": {
        "TITLE": "Назва",
        "CATEGORY": "Категорія",
        "READ_COUNT": "Перегляди",
        "STATUS": "Статус",
        "LAST_EDITED": "Останній раз відредагований"
      },
      "COLUMNS": {
        "BY": "від",
        "AUTHOR_NOT_AVAILABLE": "Автор недоступний"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Завантаження статті...",
      "TITLE_PLACEHOLDER": "Заголовок статті іде тут",
      "CONTENT_PLACEHOLDER": "Напишіть свою статтю тут",
      "API": {
        "ERROR": "Помилка при збереженні статті"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Помилка під час публікації статті",
        "SUCCESS": "Стаття успішно опублікована"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Помилка під час архівування статті",
        "SUCCESS": "Статтю успішно архівовано"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Помилка під час переведення статті в Draft",
        "SUCCESS": "Статтю успішно переведено в Draft"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Підтвердження видалення",
          "MESSAGE": "Ви дійсно бажаєте видалити статтю?",
          "YES": "Так, видалити",
          "NO": "Ні, залишити"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Стаття успішно видалена",
        "ERROR_MESSAGE": "Помилка при видаленні статті"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Будь ласка, додайте заголовок і вміст статті. Лише потім можна оновити налаштування"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Пошук статей"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Створити категорію",
        "SUB_TITLE": "Категорія буде використовуватися в публічному інтерфейсі порталу для категоризації статей.",
        "PORTAL": "Портал",
        "LOCALE": "Локаль",
        "NAME": {
          "LABEL": "Ім'я",
          "PLACEHOLDER": "Назва категорії",
          "HELP_TEXT": "Назва категорії буде використовуватися в публічному інтерфейсі порталу для категоризації статей.",
          "ERROR": "Назва обов'язкова"
        },
        "SLUG": {
          "LABEL": "Мітка",
          "PLACEHOLDER": "Мітка категорії для URL-адрес",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Необхідно вказати мітку"
        },
        "DESCRIPTION": {
          "LABEL": "Опис",
          "PLACEHOLDER": "Залиште короткий опис категорії.",
          "ERROR": "Необхідний опис"
        },
        "BUTTONS": {
          "CREATE": "Створити категорію",
          "CANCEL": "Скасувати"
        },
        "API": {
          "SUCCESS_MESSAGE": "Категорію успішно створено",
          "ERROR_MESSAGE": "Не вдалося створити категорію"
        }
      },
      "EDIT": {
        "TITLE": "Редагувати категорію",
        "SUB_TITLE": "Редагування категорії оновить категорію в порталі.",
        "PORTAL": "Портал",
        "LOCALE": "Локаль",
        "NAME": {
          "LABEL": "Ім'я",
          "PLACEHOLDER": "Назва категорії",
          "HELP_TEXT": "Назва категорії буде використовуватися в публічному інтерфейсі порталу для категоризації статей.",
          "ERROR": "Назва обов'язкова"
        },
        "SLUG": {
          "LABEL": "Мітка",
          "PLACEHOLDER": "Мітка категорії для URL-адрес",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Необхідно вказати мітку"
        },
        "DESCRIPTION": {
          "LABEL": "Опис",
          "PLACEHOLDER": "Залиште короткий опис категорії.",
          "ERROR": "Необхідний опис"
        },
        "BUTTONS": {
          "CREATE": "Оновити категорію",
          "CANCEL": "Скасувати"
        },
        "API": {
          "SUCCESS_MESSAGE": "Категорію успішно оновлено",
          "ERROR_MESSAGE": "Не вдалося оновити категорію"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Категорію успішно видалено",
          "ERROR_MESSAGE": "Не вдалося видалити категорію"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Пошук статей",
      "PLACEHOLDER": "Пошук статей",
      "NO_RESULT": "Статей не знайдено",
      "SEARCHING": "Шукаємо...",
      "SEARCH_BUTTON": "Пошук",
      "INSERT_ARTICLE": "Вставити посилання",
      "IFRAME_ERROR": "URL-адреса є пустою або недійсною. Неможливо показати вміст.",
      "OPEN_ARTICLE_SEARCH": "Вставити статтю з довідкового центру",
      "SUCCESS_ARTICLE_INSERTED": "Стаття успішно додана",
      "PREVIEW_LINK": "Перегляд статті",
      "CANCEL": "Закрити",
      "BACK": "Назад",
      "BACK_RESULTS": "Назад до результатів"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Довідковий центр",
      "DESCRIPTION": "Створіть зручні портали самообслуговування. Допоможіть вашим користувачам отримати доступ до статей та отримайте підтримку 24/7. Оновіть підписку, щоб увімкнути цю функцію.",
      "SELF_HOSTED_DESCRIPTION": "Створіть зручні портали самообслуговування. Допоможіть вашим користувачам отримати доступ до статей та отримати підтримку 24/7. Будь ласка, зверніться до адміністратора, щоб увімкнути цю функцію.",
      "BUTTON": {
        "LEARN_MORE": "Детальніше",
        "UPGRADE": "Оновити"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Кілька порталів",
          "DESCRIPTION": "Створення кількох порталів довідки для різних продуктів за допомогою одного облікового запису."
        },
        "LOCALES": {
          "TITLE": "Повна підтримка локалей",
          "DESCRIPTION": "Локалізуйте портал вашою мовою. Ми підтримуємо всі мови та дозволяємо переклади для кожної статті."
        },
        "SEO": {
          "TITLE": "SEO-дружній дизайн",
          "DESCRIPTION": "Налаштуйте мета-теги, щоб покращити видимість у пошукових системах завдяки нашим SEO-дружнім сторінкам."
        },
        "API": {
          "TITLE": "Повна підтримка API",
          "DESCRIPTION": "Використовуйте портал як headless CMS зі сторонніми фронтенд-фреймворками, використовуючи наші API."
        }
      }
    },
    "LOADING": "Завантаження...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} перегляд | {count} переглядів",
          "DROPDOWN_MENU": {
            "PUBLISH": "Опублікувати",
            "DRAFT": "Draft",
            "ARCHIVE": "Архівувати",
            "DELETE": "Видалити"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Опубліковано",
            "ARCHIVED": "Архівовано"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Без категорії"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Всі статті",
          "MINE": "Мої",
          "DRAFT": "Draft",
          "PUBLISHED": "Опубліковано",
          "ARCHIVED": "Архівовано"
        },
        "CATEGORY": {
          "ALL": "Всі категорії"
        },
        "LOCALE": {
          "ALL": "Всі локалі"
        },
        "NEW_ARTICLE": "Нова стаття"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Напишіть статтю",
          "SUBTITLE": "Напишіть змістовну статтю, почнімо!",
          "BUTTON_LABEL": "Нова стаття"
        },
        "MINE": {
          "TITLE": "Ви ще не написали тут жодної статті",
          "SUBTITLE": "Усі написані вами статті з'являються тут для швидкого доступу."
        },
        "DRAFT": {
          "TITLE": "Немає статей у Draft",
          "SUBTITLE": "Draft-статті з'являтимуться тут"
        },
        "PUBLISHED": {
          "TITLE": "Немає опублікованих статей",
          "SUBTITLE": "Опубліковані статті з'являтимуться тут"
        },
        "ARCHIVED": {
          "TITLE": "В архіві немає статей",
          "SUBTITLE": "Архівовані статті не відображаються на порталі, їх можна використовувати для позначення застарілих сторінок"
        },
        "CATEGORY": {
          "TITLE": "У цій категорії немає статей",
          "SUBTITLE": "Статті цієї категорії з'являтимуться тут"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Нова категорія",
        "EDIT_CATEGORY": "Редагувати категорію",
        "CATEGORIES_COUNT": "{n} категорія | {n} категорій",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Категорії ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} статей) | {categoryName} ({categoryCount} стаття)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Категорій не знайдено",
        "SUBTITLE": "Категорії з'являтимуться тут. Ви можете додати категорію, натиснувши кнопку «Нова категорія»."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} стаття | {count} статей",
        "EXPAND": "Показати підкатегорії",
        "COLLAPSE": "Приховати підкатегорії",
        "MENU": {
          "NEW_ARTICLE": "Нова стаття",
          "ADD_SUBCATEGORY": "Додати підкатегорію",
          "EDIT": "Редагувати",
          "DELETE": "Видалити"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Категорію успішно створено",
            "ERROR_MESSAGE": "Не вдалося створити категорію"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Категорію успішно оновлено",
            "ERROR_MESSAGE": "Не вдалося оновити категорію"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Категорію успішно видалено",
            "ERROR_MESSAGE": "Не вдалося видалити категорію"
          },
          "CONFIRM": {
            "TITLE": "Видалити категорію",
            "DESCRIPTION": "Ви впевнені, що хочете видалити цю категорію? Її статті стануть некатегоризованими.",
            "DESCRIPTION_WITH_CHILDREN": "Ви впевнені, що хочете видалити цю категорію? Її статті стануть некатегоризованими, а {count} підкатегорія переміститься на верхній рівень. | Ви впевнені, що хочете видалити цю категорію? Її статті стануть некатегоризованими, а {count} підкатегорій переміститься на верхній рівень.",
            "CONFIRM": "Видалити"
          }
        },
        "HEADER": {
          "CREATE": "Створити категорію",
          "EDIT": "Редагувати категорію",
          "DESCRIPTION": "Редагування категорії оновить категорію в порталі.",
          "PORTAL": "Портал",
          "LOCALE": "Локаль"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Ім'я",
            "PLACEHOLDER": "Назва категорії",
            "ERROR": "Назва обов'язкова"
          },
          "SLUG": {
            "LABEL": "Мітка",
            "PLACEHOLDER": "Мітка категорії для URL-адрес",
            "ERROR": "Необхідно вказати мітку",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Опис",
            "PLACEHOLDER": "Залиште короткий опис категорії.",
            "ERROR": "Необхідний опис"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Батьківська категорія",
            "PLACEHOLDER": "Виберіть батьківську категорію",
            "NONE": "Немає (верхній рівень)"
          }
        },
        "BUTTONS": {
          "CREATE": "Створити",
          "EDIT": "Оновити",
          "CANCEL": "Скасувати"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Немає доступних локалей | {n} локаль | {n} локалей",
      "NEW_LOCALE_BUTTON_TEXT": "Нова локаль",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} стаття | {count} статей",
        "CATEGORIES_COUNT": "{count} категорія | {count} категорій",
        "DEFAULT": "За замовчуванням",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Зробити за замовчуванням",
          "DELETE": "Видалити"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Додати нову локаль",
        "DESCRIPTION": "Виберіть мову, якою буде написана ця стаття. Її буде додано до вашого списку перекладів, і ви зможете додати ще пізніше.",
        "COMBOBOX": {
          "PLACEHOLDER": "Виберіть мову..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Локаль успішно додано",
          "ERROR_MESSAGE": "Не вдалося додати локаль. Спробуйте ще раз."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Збереження...",
          "SAVED": "Збережено"
        },
        "PREVIEW": "Попередній перегляд",
        "PUBLISH": "Опублікувати",
        "DRAFT": "Draft",
        "ARCHIVE": "Архівувати",
        "BACK_TO_ARTICLES": "Назад до статей"
      },
      "DRAFT": {
        "PENDING_LABEL": "Неопубліковані зміни",
        "PROMOTE": "Опублікувати зміни",
        "DISCARD": "Скасувати зміни",
        "PROMOTE_SUCCESS": "Зміни Draft опубліковано в актуальній статті",
        "PROMOTE_ERROR": "Не вдалося опублікувати зміни Draft",
        "DISCARD_SUCCESS": "Зміни Draft скасовано",
        "DISCARD_ERROR": "Не вдалося скасувати зміни Draft"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Історія версій",
        "TITLE": "Історія версій",
        "BACK": "Назад до статті",
        "LOADING": "Завантаження версій...",
        "EMPTY": "Версій поки немає. Зміни в цій статті з'являтимуться тут.",
        "EMPTY_CONTENT": "Ця версія не містить вмісту.",
        "CURRENT_BADGE": "Поточна",
        "RESTORED_BADGE": "Відновлено",
        "AUTOMATED_USER": "Автоматичне оновлення",
        "RESTORE": "Відновити цю версію",
        "RESTORE_DIALOG": {
          "TITLE": "Відновити цю версію?",
          "DESCRIPTION": "Стаття повернеться до тексту цієї версії. Нічого не буде втрачено — поточний текст залишиться в історії, а опублікована стаття продовжуватиме показувати актуальну версію, поки ви не опублікуєте зміни.",
          "CONFIRM": "Відновити"
        },
        "RESTORE_SUCCESS": "Версію відновлено",
        "RESTORE_ERROR": "Не вдалося відновити цю версію",
        "FETCH_ERROR": "Не вдалося завантажити історію версій"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Додаткові властивості",
        "TRANSLATE": "Перекласти",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Без категорії",
        "EDITOR_PLACEHOLDER": "Напишіть щось...",
        "HTML_EMBED": {
          "TITLE": "Вставити власний HTML",
          "DESCRIPTION": "Вставте необроблений HTML, наприклад iframe, embed або фрагмент віджета. Він відображатиметься як є в опублікованій статті.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Вставити"
        },
        "PRIMARY_CATEGORY": "Основна категорія"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Властивості статті",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Мета-опис",
        "META_DESCRIPTION_PLACEHOLDER": "Додати мета-опис",
        "META_TITLE": "Мета-заголовок",
        "META_TITLE_PLACEHOLDER": "Додати мета-заголовок",
        "META_TAGS": "Мета-теги",
        "META_TAGS_PLACEHOLDER": "Додати мета-теги",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Мовні версії",
        "LANGUAGE_MUTATIONS_EMPTY": "Поки що немає пов'язаних статей",
        "ADD_MUTATION": "Додати",
        "REMOVE_MUTATION": "Видалити"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Пов'язати мовні версії",
        "SEARCH_PLACEHOLDER": "Пошук статей за назвою",
        "EMPTY": "Немає відповідних статей",
        "CANCEL": "Скасувати",
        "ADD_SELECTED": "Додати вибрані",
        "SUCCESS": "Версії оновлено",
        "ERROR": "Не вдалося оновити версії"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Перекласти статтю",
        "DESCRIPTION": "Виберіть мови, на які потрібно перекласти цю статтю. Мови, які вже перекладені, будуть повторно перекладені в Draft для перевірки.",
        "EMPTY": "Немає інших доступних мов",
        "CONNECTED_BADGE": "Перекладено",
        "CANCEL": "Скасувати",
        "TRANSLATE": "Перекласти",
        "SUCCESS": "Переклад скоро розпочнеться. Перекладені статті незабаром з'являться як мовні версії.",
        "ERROR": "Не вдалося розпочати переклад"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Помилка при збереженні статті"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Новий портал",
      "PORTALS": "Портали",
      "CREATE_PORTAL": "Створюйте та керуйте кількома порталами",
      "ARTICLES": "статті",
      "DOMAIN": "домен",
      "PORTAL_NAME": "Назва порталу"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Створити новий портал",
      "DESCRIPTION": "Дайте вашому порталу назву та створіть зручний URL slug. Обидва параметри можна змінити пізніше в налаштуваннях.",
      "CONFIRM_BUTTON_LABEL": "Створити",
      "NAME": {
        "LABEL": "Ім'я",
        "PLACEHOLDER": "Посібник користувача",
        "MESSAGE": "Виберіть назву для свого порталу.",
        "ERROR": "Назва обов'язкова"
      },
      "SLUG": {
        "LABEL": "Мітка",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Необхідно вказати мітку",
        "FORMAT_ERROR": "Використовуйте лише літери, цифри та дефіси, наприклад: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Логотип",
          "IMAGE_UPLOAD_ERROR": "Не вдалося завантажити зображення! Повторіть спробу",
          "IMAGE_UPLOAD_SUCCESS": "Зображення успішно додано. Натисніть «Зберегти зміни», щоб зберегти логотип",
          "IMAGE_DELETE_SUCCESS": "Логотип успішно видалено",
          "IMAGE_DELETE_ERROR": "Не вдалося видалити логотип",
          "IMAGE_UPLOAD_SIZE_ERROR": "Зображення має бути менше {size}Мб"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Ім'я",
          "PLACEHOLDER": "Назва порталу",
          "ERROR": "Назва обов'язкова"
        },
        "HEADER_TEXT": {
          "LABEL": "Текст заголовку",
          "PLACEHOLDER": "Текст заголовку порталу"
        },
        "PAGE_TITLE": {
          "LABEL": "Заголовок сторінки",
          "PLACEHOLDER": "Заголовок сторінки порталу"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Посилання на головну сторінку",
          "PLACEHOLDER": "Посилання на головну сторінку порталу",
          "ERROR": "Недійсна URL-адреса. Посилання на головну сторінку має починатися з 'http://' або 'https://'."
        },
        "SLUG": {
          "LABEL": "Мітка",
          "PLACEHOLDER": "Мітка порталу"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Віджет живого чату",
          "PLACEHOLDER": "Виберіть віджет живого чату",
          "HELP_TEXT": "Виберіть віджет живого чату, який з'являтиметься у вашому довідковому центрі"
        },
        "LINK_TARGET": {
          "LABEL": "Ціль посилання",
          "HELP_TEXT": "Виберіть, чи відкривати посилання у статтях у поточному вікні або в новому.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Поточне вікно",
            "NEW_WINDOW": "Нове вікно"
          }
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Публічний доступ",
          "HELP_TEXT": "Зробити портал доступним для всіх, хто має посилання.",
          "OPTIONS": {
            "PUBLIC": "Так",
            "PRIVATE": "Ні"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Розмір зображення за замовчуванням",
          "HELP_TEXT": "Розмір, який застосовується до кожного зображення, яке ви вставляєте у статтю. Виберіть «Оригінал», щоб вставляти зображення в їхньому власному розмірі, або вибирайте розмір окремо для кожного зображення."
        },
        "BRAND_COLOR": {
          "LABEL": "Колір бренду"
        },
        "CUSTOM_HTML": {
          "LABEL": "Власний HTML",
          "PLACEHOLDER": "<!-- Вставте тут ваш фрагмент коду аналітики або відстеження -->",
          "HELP_TEXT": "Вставляється на початку тегу <body> на кожній сторінці довідкового центру. Використовуйте це для Google Analytics, Google Tag Manager або будь-якого іншого фрагмента коду для відстеження. Код відображається точно так, як введено, і не перевіряється."
        },
        "SAVE_CHANGES": "Зберегти зміни"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Користувацький домен",
          "LABEL": "Користувацький домен:",
          "DESCRIPTION": "Ви можете розмістити свій портал на власному домені. Наприклад, якщо ваш сайт — yourdomain.com, а ви хочете, щоб портал був доступний за адресою docs.yourdomain.com, просто введіть це в це поле.",
          "PLACEHOLDER": "Власний домен порталу",
          "EDIT_BUTTON": "Редагувати власний домен",
          "ADD_BUTTON": "Додати власний домен",
          "DIALOG": {
            "ADD_HEADER": "Додати власний домен",
            "EDIT_HEADER": "Редагувати власний домен",
            "ADD_CONFIRM_BUTTON_LABEL": "Додати домен",
            "EDIT_CONFIRM_BUTTON_LABEL": "Оновити домен",
            "LABEL": "Користувацький домен",
            "PLACEHOLDER": "Власний домен порталу",
            "ERROR": "Необхідно вказати власний домен"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Налаштування DNS",
            "DESCRIPTION": "Увійдіть в обліковий запис у вашого DNS-провайдера та додайте наведений нижче запис CNAME для вашого субдомену.",
            "HELP_TEXT": "Після цього ви можете звернутися до нашої служби підтримки, щоб запросити автоматично згенерований SSL-сертифікат.",
            "CONFIRM_BUTTON_LABEL": "Зрозуміло!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Видалити {portalName}",
          "HEADER": "Видалити портал",
          "DESCRIPTION": "Остаточно видалити цей портал. Цю дію неможливо скасувати",
          "DIALOG": {
            "HEADER": "Ви впевнені, що хочете видалити {portalName}?",
            "DESCRIPTION": "Це остаточна дія, яку неможливо скасувати.",
            "CONFIRM_BUTTON_LABEL": "Видалити"
          }
        },
        "EDIT_CONFIGURATION": "Редагувати конфігурацію"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Портал успішно створено",
          "ERROR_MESSAGE": "Не вдалося створити портал"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Портал успішно оновлено",
          "ERROR_MESSAGE": "Не вдалося оновити портал"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Вкладення",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Додати файл",
      "DROP_HERE": "Перетягніть файли сюди",
      "COPY_LINK": "Скопіювати посилання",
      "LINK_COPIED": "Посилання скопійовано в буфер обміну",
      "COPY_FAILED": "Не вдалося скопіювати посилання",
      "DELETE": "Видалити",
      "CANCEL": "Скасувати",
      "QUEUED": "У черзі",
      "UPLOADING": "Завантаження",
      "UPLOAD_FAILED": "Не вдалося завантажити файл",
      "FILE_TOO_LARGE": "Розмір файлу перевищує ліміт 40 МБ"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Словник перекладу",
        "DESCRIPTION": "Терміни, визначені тут, додаються до запиту AI-перекладу, щоб вони завжди перекладалися однаково. Ключовий термін написано мовою {locale}."
      },
      "NEW_TERM": "Новий термін",
      "EMPTY_STATE": {
        "TITLE": "У словнику ще немає термінів",
        "SUBTITLE": "Додайте термін та його переклад для кожної мови. Під час перекладу статті ці терміни застосовуються примусово, щоб формулювання вашого продукту залишалися послідовними."
      },
      "LIST": {
        "TERM": "Термін",
        "TRANSLATIONS": "Переклади",
        "ACTIONS": "Дії"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Додати термін",
          "EDIT": "Редагувати термін",
          "DESCRIPTION": "Термін нижче застосовується примусово під час AI-перекладу статей вашого центру допомоги.",
          "PORTAL": "Портал",
          "PRIMARY_LANGUAGE": "Основна мова"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Термін ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Термін обов'язковий"
          },
          "DESCRIPTION": {
            "LABEL": "Контекст / примітки (необов'язково)",
            "PLACEHOLDER": "Коли і як використовується цей термін, щоб допомогти перекладачу уникнути неоднозначності."
          },
          "TRANSLATIONS": "Переклади",
          "TRANSLATION_PLACEHOLDER": "Залиште порожнім, щоб AI перекладав вільно",
          "AUTO_TRANSLATE": {
            "BUTTON": "Автоперекласти все",
            "CONFIRM": "Перекласти на {count} мов за допомогою AI?",
            "CONFIRM_BUTTON": "Перекласти",
            "CANCEL": "Скасувати",
            "SUCCESS": "Переклади згенеровано — перевірте та збережіть",
            "ERROR": "Не вдалося автоматично перекласти, спробуйте ще раз"
          }
        },
        "BUTTONS": {
          "CREATE": "Додати термін",
          "EDIT": "Зберегти",
          "CANCEL": "Скасувати"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Термін успішно додано",
            "ERROR_MESSAGE": "Не вдалося додати термін, спробуйте ще раз"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Термін успішно оновлено",
            "ERROR_MESSAGE": "Не вдалося оновити термін, спробуйте ще раз"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Видалити термін",
          "DESCRIPTION": "Ви впевнені, що хочете видалити цей термін? Він більше не застосовуватиметься під час перекладу.",
          "CONFIRM": "Видалити"
        },
        "API": {
          "SUCCESS_MESSAGE": "Термін успішно видалено",
          "ERROR_MESSAGE": "Не вдалося видалити термін, спробуйте ще раз"
        }
      }
    }
  }
}
